import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import LanguageConfig from '../config/supported_languages';

class Header extends Component {

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    toogle_drop_language(state) {
        if('none' == getComputedStyle(this.dropdown_language).display) {
            this.dropdown_language.style.display = 'block';
        } else {
            this.dropdown_language.style.display = 'none';
        }
    }

    generate_lang_active(code) {
        let style = {}
        if(code === this.props.lang) {
            style = Object.assign(style, {
                backgroundColor: '#FFF'
            })
        }
        return style;
    }

    render() {
        const { lang, trans } = this.props;
        const code = (lang != "" ? ("/" + lang) : "");
        return (
            <div className={this.props.className} style={this.props.style}>
                {this.props.type && this.props.type === "video" && (
                    <div data-poster-url="https://daks2k3a4ib2z.cloudfront.net/59fed69e519aa50001467587/5a0fe81994280800016da6b3_IMG_0685-poster-00001.jpg" data-video-urls="https://daks2k3a4ib2z.cloudfront.net/59fed69e519aa50001467587/5a0fe81994280800016da6b3_IMG_0685-transcode.webm,https://daks2k3a4ib2z.cloudfront.net/59fed69e519aa50001467587/5a0fe81994280800016da6b3_IMG_0685-transcode.mp4" data-autoplay="true" data-loop="true" data-wf-ignore="true" className="background-video w-background-video w-background-video-atom">
                        <video autoPlay="autoplay" loop="" style={{backgroundImage:"url(&quot;https://daks2k3a4ib2z.cloudfront.net/59fed69e519aa50001467587/5a0fe81994280800016da6b3_IMG_0685-poster-00001.jpg&quot;)"}} muted="muted" data-wf-ignore="true">
                            <source src="/static/images/5a0fe81994280800016da6b3_IMG_0685-transcode.webm" data-wf-ignore="true" />
                            <source src="/static/images/5a0fe81994280800016da6b3_IMG_0685-transcode.mp4" data-wf-ignore="true" />
                        </video>
                    </div>
                )}
                <div className="hero-block-overlay business-2">
                    <div data-collapse="medium" data-animation="default" data-duration="400" className="navbar with-color-button w-nav">
                        <div className="w-container">
                            <div className={"btn-group dropright drop-menu "}>
                                <button type="button"
                                    onClick={this.toogle_drop_language.bind(this)}
                                    className="dropdown-toggle drop-content"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">{trans('language')}</button>
                                <div className="dropdown-menu" id="dropdown-menu" ref={inst => this.dropdown_language = inst}>
                                    {LanguageConfig.list.map(item =>
                                        <Link key={"lang__" + item.code} style={this.generate_lang_active(item.code)}
                                        to={"/"+item.code}>{trans(item.name)}{/*this.props.lang*/}</Link>
                                    )}
                              </div>
                            </div>
                            <a href="#" className="logo-block w-nav-brand w--current">
                                <img src={"/static/images/header-logo.png"} className="logo" width="140.5" />
                            </a>
                            <nav role="navigation" className="nav-menu w-nav-menu">
                                <Link to={"/" + lang} style={{maxWidth: "940px"}} className={"nav-link thin-light w-nav-link " + (this.props.active === "home" ? "active" : "")}>{trans('home')}</Link>
                                <Link to={code + "/pricing"} style={{maxWidth: "940px"}} className={"nav-link thin-light w-nav-link " + (this.props.active === "pricing" ? "active" : "")}>{trans('pricing')}</Link>
                                <Link to={code + "/templates"} style={{maxWidth: "940px"}} className={"nav-link thin-light w-nav-link " + (this.props.active === "templates" ? "active" : "")}>{trans('templates')}</Link>
                                <Link to={code + "/usecases"} style={{maxWidth: "940px"}} className={"nav-link thin-light w-nav-link " + (this.props.active === "use cases" ? "active" : "")}>{trans('use cases')}</Link>
                                <Link to={code + "/aboutus"} style={{maxWidth: "940px"}} className={"nav-link thin-light w-nav-link " + (this.props.active === "about us" ? "active" : "")}>{trans('about us')}</Link>
                                <Link to={code + "/contact"} style={{maxWidth: "940px"}} className={"nav-link thin-light w-nav-link " + (this.props.active === "contact" ? "active" : "")}>{trans('contact')}</Link>
                                <a target="_blank" style={{maxWidth: "940px"}} href={process.env.REACT_APP_SERVER_URL} className="nav-link with-color-2 abitbrighter w-nav-link ">{trans('open app')}</a>
                            </nav>
                            <div className="transparant-menu-button w-nav-button">
                                <div className="w-icon-nav-menu"></div>
                            </div>
                            <a href={process.env.REACT_APP_SERVER_URL} target="_blank" className="nav-link nav-link-mobile w-hidden-main w-hidden-tiny w-nav-link">{trans('Open App')}</a>
                        </div>
                        <div className="w-nav-overlay" data-wf-ignore=""></div>
                    </div>
                    <div className="container w-container">
                        <div className="full-hero-content-block">
                            <h1 style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', display: 'block', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-load" className="overall-hero-title">
                                {trans(this.props.title)}
                            </h1>
                            <p style={{opacity: 1, display: 'block', transition: 'opacity 500ms ease 0s'}} data-ix="fade-in-on-load-2" className="overall-hero-description w-hidden-tiny">
                                {trans(this.props.body)}
                            </p>
                            {this.props.children && this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default connect(state => ({
    lang: state.app.lang,
    environments: state.app.environments,
}))(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js